import React from "react";

import "./footerup.scss";

const footerup = () => {
  return (
    <div className="footerup">
      <div className="containerfooter">
        <div className="desk1">
          <h1>Visit Us!</h1>
          <div className="alamat">
            Jalan Boulevard Hijau Raya No.56, RT.003/RW.007, Medan Satria,
            Kecamatan Medan Satria, Kota Bekasi, Jawa Barat 17131
          </div>
        </div>
        <hr />
        <div className="desk2">
          Dapatkan Informasi Promo, Brosur dan Pricelist Terbaru
        </div>
        <hr />
        <div className="desk3">Contact Us: +6283899578378 (Tari)</div>
      </div>

      <a href="/privacy-policy">Privacy Policy </a>
      <div className="copyright">© All Rights Reserved, Kota Harapan Indah</div>
      <div className="powered">Powered by Linktown</div>
    </div>
  );
};

export default footerup;
